import classNames from "classnames";

export enum VARIANT {
  ERROR = "ERROR",
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
}

const DOT_COLOR: Record<VARIANT, string> = {
  [VARIANT.SUCCESS]: "text-faux-mountain-meadow",
  [VARIANT.ERROR]: "text-faux-medium-vermilion",
  [VARIANT.INFO]: "text-faux-ultramarine-blue",
  [VARIANT.WARNING]: "text-yellow-500",
};

type Props = {
  variant: VARIANT;
  className?: string;
};

const Dot = ({ variant, className }: Props) => (
  <span
    className={classNames(
      "inline-flex items-center rounded font-medium whitespace-no-wrap px-2 py-0.5",
      className,
    )}
  >
    <svg
      className={classNames("h-3 w-3", DOT_COLOR[variant])}
      fill="currentColor"
      viewBox="0 0 8 8"
    >
      <circle cx="4" cy="4" r="3" />
    </svg>
  </span>
);

export default Dot;
